module.exports = __webpack_public_path__ + "static/media/code_2.a8dcedfc.jpg";